export const SORT_OPTIONS = {
  RECENT: 'recent',
  HELPFUL: 'helpful'
};
export const VOTE = {
  YES: 'yes',
  NO: 'no'
};
export const REVIEWS_STATUS = {
  LOADING_INITIAL: 'loadingInitial',
  SUCCESS: 'success',
  REJECTED: 'rejected',
  LOADING_MORE: 'loadingMore',
  LOADING_SORT: 'loadingSort'
};
export const REVIEWS_ACTIONS = {
  SUCCESS: 'success',
  REFETCH_SUCCESS: 'refetchSuccess',
  REJECTED: 'rejected',
  LOAD_MORE: 'loadMore',
  SORT: 'sort',
  DELETE: 'delete',
  POST: 'post',
  REFETCH: 'refetch',
  DELETE_VENDOR_RESPONSE: 'deleteVendorResponse',
  SET_HOSTING_TYPE: 'setHostingType'
};